import { Player } from '../player.model';

export class Emojied {
  player: Player;
  emoji: number;
}
